import './Users.scss'
import React from 'react'
import { observer } from 'mobx-react'
import { teamStore } from '../../app/stores'
import { UserAvatar } from '../../lib'

const getUserRole = (user) => {
  if (user.is_owner) return 'Owner'
  if (user.is_admin) return 'Admin'
  return 'Member'
}

const User = ({ user }) => {
  return (
    <li className='User'>
      <UserAvatar id={user.id} />
      <div className='User_profile'>
        <h4>{user.real_name}</h4>
        <span>@{user.name}</span>
      </div>
      <div className='User_role'>
        <span>{getUserRole(user)}</span>
      </div>
    </li>
  )
}

const Users = () => {
  return (
    <div className='Users'>
      <ul>
        {[...teamStore.users].map(([key, userData]) =>
          <User key={key} user={userData.user} />
        )}
      </ul>
    </div>
  )
}

Users.displayName = 'Users'

export default observer(Users)



// WEBPACK FOOTER //
// ./src/account/users/Users.js